import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy,Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatRipple } from '@angular/material/core';

import { ViewContextStore } from 'app/navigation/view-context.service';
import { ShortStoreEnvPipe } from 'app/shared/utilities/short-store-env.pipe';

@Component({
    selector: 'admin-selectable-store-element',
    templateUrl: './selectable-store-element.component.html',
    styleUrls: ['./selectable-store-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCard, MatRipple, MatCardHeader, MatCardTitle, MatChipSet, MatChip, NgClass, MatCardSubtitle, MatCardContent, ShortStoreEnvPipe]
})
export class SelectableStoreElementComponent {
    @Input() store: ViewContextStore;
    @Input() lastAccessed?: number;
    @Output() selectStore: EventEmitter<ViewContextStore> = new EventEmitter<ViewContextStore>();

    constructor() {
    }
}
